import React from "react";
import loanApplicationUtility from "../../../utilities/LoanApplicationUtility";
import Table from "react-bootstrap/esm/Table";
import PagedList from "../../../models/accessors/pagedList";
import LoanApplication from "../../../models/loan/loanApplication";
import "./LoansListResults.css"

interface LoansListResultsProps {
    pagedLoanApplications: PagedList<LoanApplication>;
    route: any;
    noResultsText: string;
}

export default class LoansListResults extends React.Component<LoansListResultsProps> {
    render() {
        return (
            <div style={{ overflow: "auto" }}>
                {this.props.pagedLoanApplications.items && this.props.pagedLoanApplications.items.length > 0 ?
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Date Submitted</th>
                                <th>Loan Amount</th>
                                <th>Reference #</th>
                                <th>Loan Type</th>
                                <th>Auction End Date</th>
                                <th>Applicant(s)</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.pagedLoanApplications.items.map((la: LoanApplication, index: number) => {
                                return (
                                    <tr key={`loans-list-${index.toString()}`} className="loans-list-item-row" onClick={() => this.props.route.history.push(`/loan/${la.id}`)}>
                                        <td>{loanApplicationUtility.GetDateMonthNameFullYear(la.dateSubmitted)}</td>
                                        <td>{loanApplicationUtility.BuildCurrencyAmount(la.loanAmount)}</td>
                                        <td>{loanApplicationUtility.BuildDisplayId(la.id)}</td>
                                        <td>{loanApplicationUtility.GetLoanTypeText(la.loanType)}</td>
                                        <td>{la.loanAuctionInformation?.auctionEndDate ? loanApplicationUtility.GetDateMonthNameFullYear(la.loanAuctionInformation.auctionEndDate) : '--'}</td>
                                        <td>{loanApplicationUtility.JoinApplicantNames(la.applicant, la.jointApplicant)}</td>
                                        <td>{loanApplicationUtility.GetLoanStatusText(la.status)}</td>
                                    </tr>
                                )
                            })
                            }
                        </tbody>
                    </Table>
                    :
                    <h3>{this.props.noResultsText}</h3>
                }
            </div>
        )
    }
}